import AttributeConfiguration from "./AttributeConfiguration";

export default class UserConfiguration {
  public name: string;
  public configurations: AttributeConfiguration[] = [];
  public id: number;
}
